@app.directive 'filepickerPick', ->
  restrict: 'E',
  replace: true,
  require: '?ngModel',
  scope: {}
  link: (scope, element, attrs, ngModel) ->
    filepicker.setKey "ANAsscmHGSKqZCHObvuK6z"
    scope.ngModel = ngModel

  controllerAs: 'filepickerPick'
  controller: ($scope, $element) ->

    console.log 'mimetypes: ', @mimetypes
    @pick = =>

      pickOptions =
        mimetypes: @mimetypes
        services: ['COMPUTER']

      onPickSuccess = (blob) ->
        filepicker.read blob, (data) ->
          $scope.ngModel.$setViewValue(data)

      onPickError = (error) ->
        console.log error

      filepicker.pick pickOptions, onPickSuccess, onPickError

    this

  bindToController: {
    mimetypes: '='
  }

  templateUrl: "/assets/templates/directives/filepickerPick/filepickerPick.html"
